import React, { useEffect, useState, useRef } from 'react';
import './ideaCortaTod.css';
import '../../../components/modal/modal.css';

import { useCounter } from '../../../hooks/useCounter';
import Modal2 from '../../../components/modal/Modal';
import { useAxios2 } from '../../../hooks/useAxios';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';


function obtenerRuta(rutavideo) {

    var partes = rutavideo.split("src=")

    return partes[1];
}


const IdeaCortaTod = ({ dataideas }) => {

    const { counter, increment, decrement, resetCounter, defaultValue } = useCounter(0);
    const [ficha, setFicha] = useState(8);
    const [t, i18n] = useTranslation("ideaCorta");

    //cuantos registros trae
    const [numer, setNumer] = useState(`ideas/count/by-lang/es`);

    // const { data, isLoading, error } = useAxios(url);
    const [ide, setIde] = useState([]);

    useEffect(() => {
        if (dataideas) {
            setIde(dataideas);
        }
    }, [dataideas]);

    const { dataS, isLoadingS } = useAxios2(`ideas/gnideas?offset=0&next=1000&lang=${i18n.language}`);
    const location = useLocation();

    useEffect(() => {
        if (dataS) {
          dataS.map((element, index) => {
            if (location.pathname.includes(element.preview)) {
              if (element.tipo === "texto-imagen" || element.tipo === "texto-video" || element.tipo === "video" || element.tipo === "imagen" ) {
                openModal2(element.contenido, "", element.preview)
              }
              if (element.tipo === "carrete") {
                openModal2(element.contenido, "carrete", element.preview)
              }
            }
          })
        }
      }, [dataS]) 



    const verYoutu = (ruta) => {

        console.log("la ruta que se va a tratar de abri es----->" + ruta);

        // <a href={ruta} target="_blank"> ejemplo de la ruta que estoy recibiendo </a>


        window.open(ruta, '_blank');
        // <a href="https://www.ejemplo.com"> Visita nuestro sitio web </a>

    }
    const clase = (index) => {
            return "card cd_tods"
    };

    const renderizarMensaje = (tipo, contenido, preview, index) => {
        
            if (tipo === "texto") {
                return (
                    <div className="text1">
                        <div className='mensageDiv' dangerouslySetInnerHTML={{ __html: contenido }} ></div>
                    </div>
                )
                    ;
            }
            else if (tipo === "imagen") {
                return <div className='card-type-img'>
                    <img className="img1" src={'https://www.ricardosalinas.com' + preview} alt="Imagen ideas" />
                </div>
                    ;
            }
            else if (tipo === "texto-video") {
                return <div className='imageTxtContainer'>
                    <div className='playImageContainerMobile' onClick={() => openModal2(contenido, "", preview)}>
                            <div className='arrow-right'/>
                        </div>
                    <button onClick={() => openModal2(contenido, '', preview)}>
                        {/* <img className="img1 img_text_vid_grand " src={'https://www.ricardosalinas.com' + preview} alt="Imagen ideas" /> */}
                        <img className="img1 img_text_vide " src={'https://www.ricardosalinas.com' + preview} alt="Imagen ideas" />
                    </button>
                    
                </div>
                    ;
            }
            else if (tipo === "texto-imagen") {
                // return <div>
                return <>
                    <button onClick={() => openModal2(contenido, '', preview)}>
                        <img className="img1 img_text" src={'https://www.ricardosalinas.com' + preview} alt="Imagen ideas" />
                    </button>
                    <div className="cinta" onClick={() => openModal2(contenido, '', preview)}>
                        <p className="tit_LB">Leer blog</p>
                    </div>
                    {/* </div> */}
                </>
                    ;
            }
            else if (tipo === "carrete") {
                return <div>


                    <button className="boton_Lin2" onClick={() => openModal2(contenido, 'carrete')}>
                        <img className="img_carrete " src={'https://www.ricardosalinas.com' + preview} alt="Imagen ideas" />
                    </button>
                    <div className="cinta" onClick={() => openModal2(contenido, 'carrete', preview)}>
                        <p className="tit_LB">Ver galería</p>
                    </div>

                </div>
                    ;
            }
            else if (tipo === "youtube") {
                return <div className='div-youtube-list'>
                    {/* <button onClick={() => openModal2(contenido, '')}> */}
                    <button onClick={() => verYoutu(contenido)}>
                        <img className="img1 img_text" src={'https://www.ricardosalinas.com' + preview} alt="Imagen ideas" />

                    </button>
                </div>
                    ;
            }
            else if (tipo === "video") {
                return <div className='div-youtube-list'>
                    {/* <button onClick={() => openModal2(contenido, '')}>  esta es la linea originall que tenia*/}
                    <button onClick={() => verYoutu(contenido)}>
                        <img className="img1 img_text" src={'https://www.ricardosalinas.com' + preview} alt="Imagen ideas" />

                    </button>
                    
                </div>
                    ;
            }
            else {
                return <p>La condición es falsa que  tipo eres-----: {tipo}</p>;
            }
        
        };
    


    const [isModalOpen2, setIsModalOpen2] = useState(false);
    const [variable1, setVariable1] = useState('');
    const [variable2, setVariable2] = useState('');

    const openModal2 = (value1, value2, value3) => {
        console.log('SI SE USA')
        setVariable1(value1);
        setVariable2(value2);
        setIsModalOpen2(true);
        navigator.clipboard.writeText(value3).then(() => {console.log("copied")});
    };

    const closeModal2 = () => {
        setIsModalOpen2(false);
    };

    return (
        <>
            <div class="row2_LB">
                <div class="list_content--items">
                    {

                        ide.map((item, index) => (

                            <div class={clase(index)}>

                                <div className='div-card-1'>
                                    {renderizarMensaje(item.tipo, item.contenido, item.preview, index)}
                                </div>
                            </div>

                        ))
                    }

                </div>

            </div>

            <Modal2
                isOpen={isModalOpen2}
                closeModal={closeModal2}
                variable1={variable1}
                variable2={variable2}
            />

        </>

    )

}
export default IdeaCortaTod
